
import React, {  useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

// core components
import ReactTable from "components/ReactTable/ReactTable.js";




function FeaturesList(props) {

  let data = props.featuresList.map((aa,k) =>{
    
   return {
      //origional : aa,
      id: k,
      categoryCode : props.categories.categoryCode,
      valueRange : aa.valueRange,  
      //featureNameen: aa.en ,
      en : aa.en,
      ar : aa.ar,
      //featureNamear: aa.ar ,
      featureCode : aa.featureCode ,
      unit : aa.unit,
      ico  : aa.ficon,
      fib : aa.fib,
      actions: (
          // we've added some custom button actions
          <div className="actions-right" id={k}>
         
              <Button
              onClick={() => {
                  let obj = data.find((o) => o.id === k);
                  
                  props.setFvrl(obj.valueRange)
                  props.setFeatures(obj)
                  props.setShowvr(true)

              }}
              color="danger"
              size="sm"
              className="btn-icon btn-link remove"
            >
              <i className="fa fa-list" aria-hidden="true"></i>
            </Button>{" "}               
            <Button
              onClick={() => {
                  let obj = data.find((o) => o.id === k);
                  props.dellFeature(obj.categoryCode, obj.featureCode)
              }}
              color="danger"
              size="sm"
              className="btn-icon btn-link remove"
            >
              <i className="fa fa-times" />
            </Button>{" "}
          </div>
        ),
  }})

  
   

 

  return (
    <>
    
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Category Features</CardTitle>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data= {data}
                  columns={[
                    
                    {
                      Header: "Img",
                      accessor: d =>  <img alt="..." width={"30px"} src={`${d.ico}`} style={{ cursor : "pointer"}} /> ,
                    },
                   
                    {
                      Header: "Feature Code",
                      accessor: d => d.featureCode ,
                    },
                    {
                      Header: "unit",
                      accessor: d => d.unit ,
                    },
                    {
                        Header: "EN",
                        accessor: d => d.en ,
                      },

                      {
                        Header: "AR",
                        accessor: d => d.ar,
                      },
                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                    },
                  ]}
                  /*
                      You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                    */
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default FeaturesList;